import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const ASSET_TYPES_ADDITIONAL_FIELDS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'ASSET_TYPES_ADDITIONAL_FIELDS'
);
export const ASSET_TYPES_ADDITIONAL_FIELDS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	ASSET_TYPES_ADDITIONAL_FIELDS_CRUD_ACTION_CONSTANTS
);
